import React, { useEffect, useState } from 'react';
import c from 'classnames';

import './style.scss';

// This component wraps around a div and adds
// a background with the branding pattern.
const PatternBlock = ({ className, children }) => {
  // Set a state with a default ratio of 1.
  const [ratio, setRatio] = useState(1);
  // Get a reference for the object in the DOM.
  const PatternBlockRef = React.createRef();
  // Get a random number between 1 and 4.
  const patternId = Math.floor(Math.random() * 3) + 1;

  // Check if the pattern block reference is there,
  // if it is, get the dimensions of it and set the ratio.
  useEffect(() => {
    /**
     * @example
     */
    function handleResize() {
      if (PatternBlockRef) {
        const dimensions = PatternBlockRef.current.getBoundingClientRect();
        setRatio(dimensions.width / dimensions.height);
      }
    }

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, [PatternBlockRef]);

  // Set all the possible ratios.
  const PatternBlockClasses = c('PatternBlock', `pattern-id-${patternId}`, className, {
    'ratio-1x3': ratio < 0.33333,
    'ratio-1x2': ratio > 0.33333 && ratio < 0.66666,
    'ratio-1x1': ratio > 0.66666 && ratio < 2,
    'ratio-2x1': ratio < 3 && ratio > 2,
    'ratio-3x1': ratio > 3,
  });

  // Render a wrapping div.
  return (
    <div ref={PatternBlockRef} className={PatternBlockClasses}>
      {children}
    </div>
  );
};

export default PatternBlock;
